import React from "react";
import Typography from "@material-ui/core/Typography";
import { ReactComponent as FileUploadIcon } from "../../assets/svg/file-upload.svg";
import { useStyles } from "./useStyles";
import { IFileUploaderProps } from "./types";

export const UploadFileContent = ({
  browse,
  allowedFileTypes,
  maxSize,
  maxFiles,
  subText = "Drag & Drop your files here",
}: IFileUploaderProps) => {
  const classes = useStyles();

  return (
    <div className={classes.uploadContainer}>
      <FileUploadIcon />
      <div className={classes.textContainer}>
        <div>
          <Typography className={classes.textContentAndLink}>
            {subText}, or &nbsp;
            <span onClick={browse} className="wedu-link">
              browse
            </span>
          </Typography>
        </div>
        <div>
          <Typography className={classes.textInfoContent}>
            {maxSize && `File\xa0max\xa0size:\xa0${maxSize}MB. `}
            {maxFiles && `Files\xa0max\xa0count:\xa0${maxFiles}. `}
            {allowedFileTypes &&
              `Types\xa0allowed:\xa0${allowedFileTypes
                .map((t) => t.toUpperCase())
                .join(",\xa0")}.`}
          </Typography>
        </div>
      </div>
    </div>
  );
};
